import React from 'react';
import { Box } from '@mui/material';
import ProgramProfile from '../components/programs/ProgramProfile';

const ProgramProfilePage: React.FC = () => {
  return (
    <Box sx={{ p: 2 }}>
      <ProgramProfile />
    </Box>
  );
};

export default ProgramProfilePage; 